// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusOutlinedSvg from "@ant-design/icons-svg/es/asn/PlusOutlined";
import AntdIcon from '../components/AntdIcon';

var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusOutlinedSvg
  }));
};

PlusOutlined.displayName = 'PlusOutlined';
export default /*#__PURE__*/React.forwardRef(PlusOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js
// module id = 752
// module chunks = 0